import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import Wrapper from "../atoms/Wrapper";
import RowIntroductionStream from "./RowIntroductionStream";
import {
  get_vtuber_introductions,
  reset_vtuber_introductions,
} from "../../actions/introduction";

const StyledWrapper = styled(Wrapper)`
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  width: fit-content;
  width: 100%;
`;

const Message = styled.div`
  color: ${(props) => props.theme.colors.gray};
  width: 100%;
  text-align: center;
  padding: 1.5rem 0.8rem;
  line-height: 3.8rem;
`;

const VTuberIntroductionStream = (props) => {
  const dispatch = useDispatch();
  const { page, state, items, has_more } = useSelector(
    (state) => state.introduction.vtuber_introductions
  );
  const loadMore = (page) => {
    props.vtuber_id &&
      dispatch(get_vtuber_introductions(props.vtuber_id)(page));
  };

  React.useEffect(() => {
    return () => dispatch(reset_vtuber_introductions());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(reset_vtuber_introductions());
  }, [dispatch, props.vtuber_id]);

  return (
    <StyledWrapper>
      {props.name && (
        <RowIntroductionStream
          items={items}
          loadMore={loadMore}
          page={page}
          hasMore={has_more}
          requestState={state}
          vtuber_id={props.vtuber_id}
        />
      )}
      {state !== "request" &&
        state !== "sleep" &&
        items &&
        items.length === 0 && (
          <Message>このVTuberの紹介がまだありません。</Message>
        )}
    </StyledWrapper>
  );
};

export default VTuberIntroductionStream;
